import { ArrowPathIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useState, useMemo } from "react";
import Button from "src/components/form/Button";
import Modal from "src/components/shared/Modal";
import { apiUrl } from "src/config/host";
import { encodeRelayState } from "src/helpers/urlBuilder";

export const MultiSsoModal = ({ isModal = true, ssoModal, setSsoModal, ssos, site, mode = "neutral" }) => {
  const [loadingId, setLoadingId] = useState(null);

  const providers = useMemo(
    () =>
      (ssos ?? []).map((item) => ({
        id: item._id,
        label: `Continue with ${item.provider_name}`,
        name: item.provider_name,
        href: `${apiUrl}/login-sso?RelayState=${encodeRelayState({
          origin: window.location.origin,
          sso_id: item._id,
        })}`,
      })),
    [ssos],
  );

  const handleClick = (id, href) => {
    setLoadingId(id);
    window.location.href = href;
  };

  const SsoList = () => {
    return (
      <div className="space-y-4">
        {isModal && (
          <div className="mt-4 text-center">
            <div
              onClick={() => setSsoModal(false)}
              className="mt-4 text-center">
              <div className="text-regular mt-2 text-center font-medium text-gray-600 ">
                Back to
                <span className="cursor-pointer pl-1 text-highlightColor hover:underline">Login</span>
              </div>
            </div>
          </div>
        )}
        <div className="space-y-3">
          {providers.map((p) => {
            const isLoading = loadingId === p.id;
            return (
              <Button
                buttonClasses={"w-full"}
                buttonLabelClasses={"!px-1 !font-normal !w-full justify-between flex"}
                buttonHasLink={false}
                buttonLabel={
                  <>
                    <span className="flex-1 truncate text-left">{p.label}</span>
                    <span className={"ml-2 inline-flex items-center"}>{isLoading ? <ArrowPathIcon className="h-4 w-4 animate-spin" /> : <ArrowRightIcon className="h-4 w-4" />}</span>
                  </>
                }
                buttonFunction={() => handleClick(p.id, p.href)}
                buttonStyles={{
                  borderColor: site?.sso_button_text_color,
                  color: site?.sso_button_text_color || "#fff",
                  backgroundColor: site?.sso_button_color,
                }}
              />
            );
          })}
        </div>
      </div>
    );
  };

  if (!isModal) {
    return <SsoList />;
  }

  return (
    <Modal
      isOpen={ssoModal}
      defaultHeader={false}
      size="sm"
      defaultOptions={{
        onCancelButtonVisible: false,
        onSuccessButtonVisible: false,
        headerVisible: false,
      }}
      onCancel={() => setSsoModal(false)}>
      <SsoList />
    </Modal>
  );
};
